import { render } from "./codeEditor.vue?vue&type=template&id=6f8a8430&scoped=true"
import script from "./codeEditor.vue?vue&type=script&lang=js"
export * from "./codeEditor.vue?vue&type=script&lang=js"

import "./codeEditor.vue?vue&type=style&index=0&id=6f8a8430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8a8430"]])

export default __exports__